/**
 * TanStack Query hooks for `self-serve-credit-card-subscribe`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	selfServeCreditCardSubscribeQueryKeys,
	type CreateSelfServeCreditCardSubscribeBody,
	type ListSelfServeCreditCardSubscribeResponse,
	type SelfServeCreditCardSubscribeRow,
} from "./api";

export function useSelfServeCreditCardSubscribeList(): UseQueryResult<ListSelfServeCreditCardSubscribeResponse, Error> {
	return useQuery({
		queryKey: selfServeCreditCardSubscribeQueryKeys.list(),
		queryFn: list,
	});
}

export function useSelfServeCreditCardSubscribeCreate(): UseMutationResult<SelfServeCreditCardSubscribeRow, Error, CreateSelfServeCreditCardSubscribeBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: selfServeCreditCardSubscribeQueryKeys.all });
		},
	});
}

export function useSelfServeCreditCardSubscribeDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: selfServeCreditCardSubscribeQueryKeys.all });
		},
	});
}
